// 로그인 저장값을 정리하고 홈으로 이동 (Header 로그아웃, 이벤트 경품 지급 완료 팝업에서 공용)
export const clearLoginAndGoHome = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('nickName');
  localStorage.removeItem('walletAddress');
  localStorage.removeItem('eventLogin');

  const isAvataroad = /\.avataroad\.com$/.test(window.location.hostname);
  const cookieParts = [
    'ar_nickname=',
    'Path=/',
    'Max-Age=0',
    'SameSite=Lax',
  ];
  if (isAvataroad) {
    cookieParts.push('Domain=.avataroad.com');
  }
  if (window.location.protocol === 'https:') {
    cookieParts.push('Secure');
  }
  document.cookie = cookieParts.join('; ');

  window.location.href = '/';
};
